import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetNotTreatedAPI = api.create('dponet', false)

const get = async ({ governanceProjectId, id, ...params }) => {
  return await dponetAPI.get(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}`,
    { params },
  )
}

const list = async ({ governanceProjectId, ...params }) => {
  return await dponetAPI.get(
    `/governance_projects/${governanceProjectId}/governance_project_activities`,
    { params },
  )
}

const answer = async ({ governanceProjectId, id, ...params }) => {
  return await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/answer`,
    {
      governanceProjectActivity: params,
    },
  )
}

const changeStatus = async ({ governanceProjectId, id, ...params }) => {
  return await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/change_status`,
    {
      governanceProjectActivity: params,
    },
  )
}

const reopen = async ({ governanceProjectId, id }) =>
  await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/reopen`,
  )

const updateAssignment = async ({ governanceProjectId, id, ...params }) =>
  await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/assignment`,
    { governanceProjectActivity: params },
  )

const assumeRisk = async ({ governanceProjectId, id, ...params }) =>
  await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/assume_risk`,
    params,
  )

const undoRiskAssumption = async ({ governanceProjectId, id }) =>
  await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/undo_risk_assumption`,
  )

const daiAnalysis = async ({ governanceProjectId, id }) => {
  return await dponetNotTreatedAPI.post(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/dai_analysis`,
  )
}

const daiAnalysisFeedback = async ({
  governanceProjectId,
  governanceProjectActivityId,
  daiResponseId,
  params,
}) => {
  return await dponetNotTreatedAPI.post(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${governanceProjectActivityId}/dai_analysis/${daiResponseId}/feedback`,
    params,
  )
}

const contest = async ({ governanceProjectId, id, ...params }) => {
  return await dponetNotTreatedAPI.post(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/contest`,
    { contest: params },
  )
}

const generateSoaFile = async ({ governanceProjectId, id }) => {
  return await dponetNotTreatedAPI.post(
    `/governance_projects/${governanceProjectId}/governance_project_activities/${id}/export/soa`,
    {},
  )
}

export default {
  get,
  list,
  answer,
  changeStatus,
  reopen,
  updateAssignment,
  assumeRisk,
  undoRiskAssumption,
  contest,
  daiAnalysis,
  daiAnalysisFeedback,
  generateSoaFile,
}
